var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrisCopilotIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.142 7.32501C33.5631 5.35387 31.7544 4 29.7 4L28.3484 4C26.1139 4 24.1982 5.59611 23.7949 7.79398L21.4802 20.4072L22.0546 18.4419C22.6316 16.4679 24.4416 15.1111 26.4983 15.1111H34.3521L37.6458 16.3942L40.8209 15.1111H39.8942C37.8398 15.1111 36.0312 13.7572 35.4522 11.7861L34.142 7.32501Z",
    fill: "url(#paint0_radial_262034_2112)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3304 40.656C14.9029 42.6367 16.7162 44 18.778 44H21.6483C24.1589 44 26.2119 41.999 26.2764 39.4893L26.589 27.3271L25.9351 29.5603C25.3574 31.5332 23.5478 32.8889 21.492 32.8889L13.5729 32.8889L10.7496 31.3573L7.69305 32.8889H8.6043C10.666 32.8889 12.4793 34.2523 13.0518 36.2329L14.3304 40.656Z",
    fill: "url(#paint1_radial_262034_2112)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4993 4H13.46C8.87732 4 6.12772 10.0566 4.29466 16.1132C2.12296 23.2886 -0.718769 32.8852 7.50252 32.8852H14.4282C16.4978 32.8852 18.3147 31.5168 18.8835 29.5269C20.0876 25.3143 22.1978 17.9655 23.8554 12.3712C24.6977 9.52831 25.3993 7.08673 26.4762 5.56628C27.0799 4.71385 28.086 4 29.4993 4Z",
    fill: "url(#paint2_linear_262034_2112)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4993 4H13.46C8.87732 4 6.12772 10.0566 4.29466 16.1132C2.12296 23.2886 -0.718769 32.8852 7.50252 32.8852H14.4282C16.4978 32.8852 18.3147 31.5168 18.8835 29.5269C20.0876 25.3143 22.1978 17.9655 23.8554 12.3712C24.6977 9.52831 25.3993 7.08673 26.4762 5.56628C27.0799 4.71385 28.086 4 29.4993 4Z",
    fill: "url(#paint3_linear_262034_2112)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4977 44H34.537C39.1197 44 41.8693 37.9424 43.7023 31.8847C45.874 24.708 48.7157 15.1098 40.4945 15.1098H33.5689C31.4993 15.1098 29.6824 16.4784 29.1136 18.4684C27.9095 22.6816 25.7992 30.0319 24.1416 35.6273C23.2993 38.4707 22.5976 40.9127 21.5208 42.4334C20.9171 43.286 19.9109 44 18.4977 44Z",
    fill: "url(#paint4_radial_262034_2112)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4977 44H34.537C39.1197 44 41.8693 37.9424 43.7023 31.8847C45.874 24.708 48.7157 15.1098 40.4945 15.1098H33.5689C31.4993 15.1098 29.6824 16.4784 29.1136 18.4684C27.9095 22.6816 25.7992 30.0319 24.1416 35.6273C23.2993 38.4707 22.5976 40.9127 21.5208 42.4334C20.9171 43.286 19.9109 44 18.4977 44Z",
    fill: "url(#paint5_linear_262034_2112)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_262034_2112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0047 20.5144) rotate(-129.304) scale(17.3033 16.2706)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955758,
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773185,
    stopColor: "#2253CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_262034_2112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1212 32.8171) rotate(51.84) scale(15.9912 15.5119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633728,
    stopColor: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923392,
    stopColor: "#C02B3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_262034_2112",
    x1: 12.5,
    y1: 7.5,
    x2: 14.7884,
    y2: 33.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156162,
    stopColor: "#0D91E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487484,
    stopColor: "#52B471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652394,
    stopColor: "#98BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937361,
    stopColor: "#FFC800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_262034_2112",
    x1: 14.5,
    y1: 4,
    x2: 15.7496,
    y2: 32.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246674,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_262034_2112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3184 12.2812) rotate(109.274) scale(38.3873 45.9867)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661714,
    stopColor: "#8C48FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#FFB152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_262034_2112",
    x1: 42.5855,
    y1: 13.346,
    x2: 42.5692,
    y2: 21.2147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581535,
    stopColor: "#F8ADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708063,
    stopColor: "#A86EDD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrisCopilotIcon);
export default __webpack_public_path__ + "static/media/iris-copilot-icon.8cb4e39ad90459307f9524621d11bc36.svg";
export { ForwardRef as ReactComponent };